exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager #id-form .headline,#doc-manager #id-form .logo-container{margin-top:30px}#doc-manager #id-form .headline-text{font-size:24px;font-weight:700}#doc-manager #id-form .headline-label{margin-top:16px}#doc-manager #id-form .form-container{margin-top:15px}#doc-manager #id-form .form-container label{font-size:12px}#doc-manager #id-form .input-container{min-height:36px}#doc-manager #id-form .input{min-height:36px;min-width:300px;max-width:300px;font-size:14px;-webkit-box-flex:0.18;-ms-flex:0.18;flex:0.18}#doc-manager #id-form .fetch-button{min-width:80px;padding:0 20px;font-size:13px}", ""]);

// exports
